import axios, { AxiosError } from "axios";
import { API_URL, InqueryRequest, InqueryResponse } from "../constant";


export async function api_quota_inquery(requestdata: InqueryRequest): Promise<InqueryResponse> {

    try {
        const response = await axios.post(
            `${API_URL}api/inquery/add`,
            requestdata,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );

        if (response.status === 204) {
            return { success: true, msg: "" };
        }
        else {
            return { success: false, msg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, msg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, msg: "No response received from server" };
        } else {
            return { success: false, msg: `Error:, ${error.message}` };
        }
    }
}